import { useCurrentUserProfile } from '@alliance-disposal/client';
import { roleEnums } from '../utils/user-role-types';

export const useRestrictedAccess = () => {
    const { profile } = useCurrentUserProfile();
    const roles = profile?.authorities.flatMap((authority) => authority.roles) ?? [];

    return {
        isBillingUser: roles.includes(roleEnums.BILLING),
        isDispatchUser: roles.includes(roleEnums.DISPATCH),
    };
};
